// https://sooncoding.tistory.com/336
import Script from "next/script";

const KAKAO_JS_KEY = "00b7950c796e9869bb457916a1817117";

declare global {
  interface Window {
    Kakao: {
      init: (key: string) => void;
      isInitialized: () => boolean;
      Share: {
        sendScrap: (options: {
          requestUrl: string;
          templateId: number;
          templateArgs: Record<string, string>;
        }) => void;
      };
    };
  }
}

export function KakaoInitializer() {
  return (
    <Script
      src="https://t1.kakaocdn.net/kakao_js_sdk/2.7.9/kakao.min.js"
      integrity="sha384-JpLApTkB8lPskhVMhT+m5Ln8aHlnS0bsIexhaak0jOhAkMYedQoVghPfSpjNi9K1"
      crossOrigin="anonymous"
      strategy="afterInteractive"
      onLoad={() => {
        window.Kakao.init(KAKAO_JS_KEY);
      }}
    />
  );
}
